function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M18,9a9,9,0,0,1-9,9,8.82,8.82,0,0,1-3.38-.66,8,8,0,0,1-1-.47,8.91,8.91,0,0,1-3.51-3.51,6.63,6.63,0,0,1-.46-1A8.87,8.87,0,0,1,0,9,9,9,0,0,1,9,0a8.87,8.87,0,0,1,3.39.67,6.63,6.63,0,0,1,1,.46,8.91,8.91,0,0,1,3.51,3.51,8,8,0,0,1,.47,1A8.85,8.85,0,0,1,18,9Z",
  fill: "#848890"
}), React.createElement("path", {
  d: "M17.34,5.62,13.92,9a2.49,2.49,0,0,1-1.77.73A2.45,2.45,0,0,1,10.39,9l-.31-.31L8.72,10.08l.31.31a2.49,2.49,0,0,1,.73,1.77A2.52,2.52,0,0,1,9,13.93L5.62,17.34a8,8,0,0,1-1-.47.79.79,0,0,0,.15-.12l3.53-3.53a1.47,1.47,0,0,0,.44-1.06,1.46,1.46,0,0,0-.44-1.06L8,10.79,6.22,12.58a.54.54,0,0,1-.39.16.55.55,0,0,1-.4-.16.57.57,0,0,1,0-.8L7.22,10l-.31-.31a1.51,1.51,0,0,0-1.06-.44,1.49,1.49,0,0,0-1.06.44L1.25,13.22a.81.81,0,0,0-.12.14,6.63,6.63,0,0,1-.46-1L4.08,9A2.5,2.5,0,0,1,7.62,9l.31.31L9.28,7.93,9,7.62A2.51,2.51,0,0,1,9,4.08L12.39.67a6.63,6.63,0,0,1,1,.46l-.15.13L9.68,4.79a1.5,1.5,0,0,0,0,2.12l.31.31,1.8-1.8a.57.57,0,0,1,.8,0,.56.56,0,0,1,0,.79L10.78,8l.31.31a1.51,1.51,0,0,0,2.12,0l3.54-3.54a.79.79,0,0,0,.12-.15A8,8,0,0,1,17.34,5.62Z",
  fill: "#fff"
})));

function SvgConnect(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/connect.c40f0919.svg";
export { SvgConnect as ReactComponent };